module.exports = __webpack_public_path__ + "img/horse.9e84ec73.svg";